import { getSimDetails, tccRegisterApi, byPassVerification } from "../api/api";
import { SequenceManagerAction } from "./SequenceManagerAction";

const UnifiedAbsherVerificationAction = {
  GET_SIM_DETAILS_SUCCESS : "GET_SIM_DETAILS_SUCCESS",
  GET_SIM_DETAILS_FAILURE : "GET_SIM_DETAILS_FAILURE",
  TCC_REGISTRATION_FAILURE : "TCC_REGISTRATION_FAILURE",
  TCC_REGISTRATION_SUCCESS : "TCC_REGISTRATION_SUCCESS",
  ABSHER_VERIFICATION_COMPLETE : "ABSHER_VERIFICATION_COMPLETE",
  BYPASS_VERIFICATION_SUCCESS : "BYPASS_VERIFICATION_SUCCESS",
  BYPASS_VERIFICATION_FAILURE : "BYPASS_VERIFICATION_FAILURE"
} as const;

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];

let getSimDetailsCounter = 0;

const unifiedGetSimTypeDetails = (NewStack: any) => {
  return function (dispatch: any) {
    getSimDetails(NewStack)
      .then((response) => {
        console.log(response);
        dispatch({ type: UnifiedAbsherVerificationAction.GET_SIM_DETAILS_SUCCESS, payload: response });
      })
      .catch((err) => {
        //Display error
        const config = Object.assign(err?.config, { serviceName: 'getESimDetails' });
        const error = { ...err, config };

        if (error?.response?.status) {
          dispatch({ type: UnifiedAbsherVerificationAction.GET_SIM_DETAILS_SUCCESS, payload: error?.response });
        } else {
          ++getSimDetailsCounter
          if (getSimDetailsCounter < retryCount) {
            const objData = JSON.parse(error?.config?.data);
            dispatch(unifiedGetSimTypeDetails(objData?.NewStack));
          } else {
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          }
        }
      })
  }
}

const unifiedTccRegisterDetails = (IAMToken: any, requestType: any, sim: any, imsi: any, msisdnNumber: any, idNumber: any, Nationality: any, payType: any, appToken: any, exceptionFlag: any, newStack: any) => {
  sessionStorage.removeItem('nafathAppToken'); // remove nafath app token from session storage

  return function (dispatch: any) {
    tccRegisterApi(IAMToken, requestType, sim, imsi, msisdnNumber, idNumber, Nationality, payType, appToken, exceptionFlag, newStack)
      .then((response) => {
        dispatch({ type: UnifiedAbsherVerificationAction.TCC_REGISTRATION_SUCCESS, payload: response });
      })
      .catch((error) => {
        //Display error
        if (error?.response) {
          dispatch({ type: UnifiedAbsherVerificationAction.TCC_REGISTRATION_SUCCESS, payload: error?.response });
        } else {
          // dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          dispatch({ type: UnifiedAbsherVerificationAction.TCC_REGISTRATION_SUCCESS, payload: error });
        }
      })
  }
}

const unifiedByPassVerificationCall = () => {
  return function (dispatch: any) {
    byPassVerification().then((response) => {
      dispatch({ type: UnifiedAbsherVerificationAction.BYPASS_VERIFICATION_SUCCESS, payload: response });
    })
      .catch((error) => {
        //Display error
        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
      })
  }
}

const unifiedStoreTccRegisterDetails = (IAMToken: any, simDetails: any, tccRegisterResponse: any, ocId: any, nafathOption: any) => {
  return function (dispatch: any) {
    dispatch({ type: UnifiedAbsherVerificationAction.ABSHER_VERIFICATION_COMPLETE, payload: { IAMToken: IAMToken, simDetails: simDetails, tccRegisterResponse: tccRegisterResponse, ocId: ocId, nafathOption: nafathOption } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['UnifiedAbsherVerification'] });
    // dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['AbsherVerification'] });
  }
}

export { UnifiedAbsherVerificationAction, unifiedGetSimTypeDetails, unifiedTccRegisterDetails, unifiedStoreTccRegisterDetails, unifiedByPassVerificationCall };
